import * as actionTypes from "../actions/types";

const initialState = {
  userId: "",
  userToken: "",
  refreshToken: "",
  drawerOpen: true,
  restaurantData: null,
  themeMode: "light",
  restaurantCourseList: [],
  restaurantCategoryList: [],
  restaurantMenuList: [],
  selectedMenuCategory: "",
};

const userDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_USER_TOKEN:
      return {
        ...state,
        userToken: action.payload,
      };

    case actionTypes.UPDATE_REFRESH_TOKEN:
      return {
        ...state,
        refreshToken: action.payload,
      };

    case actionTypes.UPDATE_DRAWER_OPEN:
      return {
        ...state,
        drawerOpen: action.payload,
      };

    case actionTypes.UPDATE_RESTAURANT_DATA:
      return {
        ...state,
        restaurantData: action.payload,
      };

    case actionTypes.UPDATE_USER_ID:
      return {
        ...state,
        userId: action.payload,
      };

    case actionTypes.UPDATE_FEATURES_LIST:
      return {
        ...state,
        restaurantData: {
          ...state.restaurantData,
          featureFlags: action.payload,
        },
      };

    case "LOG_OUT":
      return {
        ...state,
        userId: "",
        userToken: "",
        refreshToken: "",
        drawerOpen: true,
        restaurantData: null,
        restaurantCourseList: [],
        restaurantCategoryList: [],
        restaurantMenuList: [],
      };
    case actionTypes.UPDATE_RESTAURANT_COURSE_LIST:
      return {
        ...state,
        restaurantCourseList: action.payload,
      };

    case actionTypes.UPDATE_RESTAURANT_CATEGORY_LIST:
      return {
        ...state,
        restaurantCategoryList: action.payload,
      };
    case actionTypes.UPDATE_RESTAURANT_MENU_LIST:
      return {
        ...state,
        restaurantMenuList: action.payload,
      };
    case actionTypes.UPDATE_SELECTED_MENU_CATEGORY:
      return {
        ...state,
        selectedMenuCategory: action.payload,
      };
  }
  return state;
};

export default userDataReducer;
